module.exports = __webpack_public_path__ + "static/atlaskit-avatar-presence-e5d2bef0def49095e3c65fe766bd9c54.png";